/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UsedCoverage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function UsedCoverage({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/InsurancePaymentAccount/Content/Content/UsedCoverage"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let insuredTxCategoryInsuredOrthoInsuredUsedLifetimeCoverageValueData = fromData.useDataFormat({ viewPath,
context: 'insured',
path: 'tx_category_insured.ortho_insured.used_lifetime_coverage',
format: fromHelpers.getText,
})
  return (<React.Fragment
>
<div
  data-testid="UsedCoverage.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Coverage used"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insured.tx_category_insured.ortho_insured.used_lifetime_coverage"
 format="helpers.js getText"
 text={insuredTxCategoryInsuredOrthoInsuredUsedLifetimeCoverageValueData}
/>
</div>
{children}
</React.Fragment>)
}